export { default } from './NavigationAnchors';
